import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

let block = document.querySelector('.page-top');

if (block) {

    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: block,
            start: 'top 80%',
        },
        defaults: { ease: 'power2.out' }
    });

    tl.from(block.querySelectorAll('.text-wrapper > *'), {
        autoAlpha: 0,
        y: 30,
        duration: 0.6,
        stagger: 0.1,
    });

    tl.from(block.querySelector('figure'), {
        autoAlpha: 0,
        x: 50,
        duration: 0.75,
    }, '-=0.4');
}